import { GET_ALL_SETTING_DAYS } from '../../js/constants/setting_days';

export const utilityMixin = {
    data () {
        return {
            dayOfWeekStr: [ "日", "月", "火", "水", "木", "金", "土" ],
            breakPoint: '896px',
        };
    },
    created () {
        //
    },
    methods: {
        /** ----------------------------------------------
         * 日付文字列取得
         *  引数を文字列（YYYY-MM-DD）に編集する。
         *  引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY-MM-DD）
         * ---------------------------------------------- */
        getDateStr (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate =  date
            }
            var targetDateStr =
                    targetDate.getFullYear() + '-' +
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) + '-' +
                    ('0' + targetDate.getDate()).slice(-2);
            return targetDateStr;
        },
        /** ----------------------------------------------
         * 日付文字列取得
         *  引数を文字列（YYYY年MM月DD日）に編集する
         *  引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY年MM月DD日）
         * ---------------------------------------------- */
        getDateStrJapanese (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate =  date
            }
            var targetDateStr =
                    targetDate.getFullYear() + '年' +
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) + '月' +
                    ('0' + targetDate.getDate()).slice(-2) + '日';
            return targetDateStr;
        },
        /** ----------------------------------------------
         * 日付文字列取得
         *  引数を文字列（YYYY年MM月DD日）に編集し01月を1月の表記で取得する
         *  引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY年MM月DD日）
         * ---------------------------------------------- */
         getDateBindStrJapanese (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate =  date
            }
            var targetDateStr =
                    targetDate.getFullYear() + '年' +
                    Number(('0' + (targetDate.getMonth() + 1)).slice(-2)) + '月' +
                    Number(('0' + targetDate.getDate()).slice(-2)) + '日';
            return targetDateStr;
        },
        /** ----------------------------------------------
         * 時刻文字列取得
         *  引数を文字列（H:MM）に編集する（時は0サプライしない）
         *  引数がnullの場合は現在時刻を編集する。
         * @param  {String} time 時刻(HH:MM:SS)
         * @return {String} 時刻文字列（H:MM）
         * ---------------------------------------------- */
        getTimeStr (time) {
            var workDate;
            if (time == null) {
                workDate = new Date();
            } else {
                workDate =  new Date('2020/01/01 ' + time);
            }

            var targetTimeStr =
                    workDate.getHours() + ':' +
                    ('0' + (workDate.getMinutes())).slice(-2);

            return targetTimeStr;
        },
        /** ----------------------------------------------
         * 時刻文字列取得
         *  引数を文字列（H時MM分）に編集する（時は0サプライしない）
         *  引数がnullの場合は現在時刻を編集する。
         * @param  {String} time 時刻(HH:MM:SS)
         * @return {String} 時刻文字列（H時MM分）
         * ---------------------------------------------- */
        getTimeStrJapanese (time) {
            var workDate;
            if (time == null) {
                workDate = new Date();
            } else {
                workDate =  new Date('2020/01/01 ' + time);
            }

            var targetTimeStr =
                    ('0' + (workDate.getHours())).slice(-2) + '時' +
                    ('0' + (workDate.getMinutes())).slice(-2) + '分';

            return targetTimeStr;
        },
        /** ----------------------------------------------
         * 曜日取得
         *  曜日を取得する
         *  引数がnullの場合は現在日の曜日を取得する
         * @param  {Date} date 日付
         * @return {String} 曜日
         * ---------------------------------------------- */
        getDayJapanese (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate =  date
            }

            return this.dayOfWeekStr[targetDate.getDay()];
        },
        /** ----------------------------------------------
         * 曜日判定
         *  曜日を判定する
         *  引数がnullの場合は現在日の曜日を判定する
         * @param  {Date} date 日付
         * @param  {Array, Object} settingDayTbl 祝日データ
         * @return {Int}} 平日:0 土:1 日祝:2
         * ---------------------------------------------- */
        judgeDay: function (date, settingDayTbl) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate =  date
            }

            var judge = 0;

            var targetDateStr =
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) +
                    ('0' + targetDate.getDate()).slice(-2);
            var targetDateWeek =
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) +
                    ('0' + (Math.floor((targetDate.getDate() + 6 ) / 7))).slice(-2) +
                    ('0' + (targetDate.getDay())).slice(-2);

            for (var i = 0 ; i < settingDayTbl.length ; i++) {
                // 曜日指定タイプが日付固定の場合
                if (settingDayTbl[i].date_type == 1) {
                    if (settingDayTbl[i].month_day == targetDateStr) {
                        judge = 2;
                        break;
                    }
                // 曜日指定タイプが対象日指定の場合
                } else {
                    if (settingDayTbl[i].month_day == targetDateWeek) {
                        judge = 2;
                        break;
                    }
                }
            }

            // 祝日以外の場合
            if (judge == 0) {
                var dayNum = targetDate.getDay();
                // 日曜の場合
                if (dayNum == 0) {
                    judge = 2;
                // 土曜の場合
                } else if (dayNum == 6) {
                    judge = 1;
                }
            }

            return judge;
        },
        /** ----------------------------------------------
         * 予約締切時間チェック
         * @param
         * @return Boolean true:予約締切時間内  false:予約締切時間オーバー
         * ---------------------------------------------- */
        checkClosingDate: function (startDate, closingDays, closingTime) {
            // 予約締切日が過ぎていないかチェック
            // let now = this.getDateStr() + ' ' + this.getTimeStr();

            if (!closingDays) {
                closingDays = 0
            }

            if (!closingTime) {
                closingTime = "00:00:00"
            }

            // 現在の日付をDate型で取得する。
            let now = new Date();
            let dt = new Date(startDate);
            dt.setDate(dt.getDate() - closingDays);
            let time = closingTime.split(":");
            dt.setHours(time[0]);
            dt.setMinutes(time[1]);
            if (dt.getTime() < now.getTime()) {
                return false;
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * モバイル判定
         * ---------------------------------------------- */
        checkMobile () {
            if (window.matchMedia && window.matchMedia('(max-width: ' + this.breakPoint + ')').matches) {
                return true;
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 日付文字列取得
         *  引数を文字列（YYYY-MM-DD HH:MM:SS）に編集する。
         *  引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY-MM-DD）
         * ---------------------------------------------- */
        getDateFullStr (date) {
            let targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate =  date
            }
            const targetDateStr =
                    targetDate.getFullYear() + '-' +
                    (targetDate.getMonth() + 1) + '-' +
                    targetDate.getDate() + ' ' +
                    targetDate.getHours() + ':' +
                    targetDate.getMinutes() + ':' +
                    targetDate.getSeconds();
            return targetDateStr;
        },
        checkTodaySmall (target) {
            const today = new Date();
            const smaller = new Date(target);
            return today.getTime() > smaller.getTime();
        },
        /** ----------------------------------------------
         * 半角カタカナを全角カタカナに変換する。
         * @param  {String} val 変換対象の文字
         * @return {String} 変換後の文字
         * ---------------------------------------------- */
        hankanaChangeZenkana (val) {
            var kanaMap = {
                'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
                'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
                'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
                'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
                'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
                'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
                'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
                'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
                'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
                'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
                'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
                'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
                'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
                'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
                'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
                'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
                'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
                'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
                '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
            };

            var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
            return val.replace(reg, function (match) { return kanaMap[match];}).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
        },
    }

};
